import { LOAD_THEME_SETTINGS, SET_WISHLIST_LABEL } from '../actions/wishlistLabelActions';

const initialState = {
  wishlistRelabel: 'Wishlist',
};

const themeReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_WISHLIST_LABEL:
      return {
        ...state,
        wishlistRelabel: action.payload,
      };
    case LOAD_THEME_SETTINGS:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default themeReducer;
